import { Button, Col, Modal, notification, Space, Switch, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  getServicesByProviderId,
  updateProviderService,
} from "../../../../services/providerService";
import { ProviderServiceStatus } from "../../../../shared/constants/ProviderServiceStatus";
import DriverServiceForm from "../form";

import "../../../../shared/styles/list.css";
import { PlusCircleTwoTone } from "@ant-design/icons";
import ContainerLayout from "../../../common/containerLayout";
import { DataType } from "../types";

const DriverServiceList = () => {
  const title = "Servicios asociados al conductor";

  const [data, setData] = useState<DataType[]>([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [providerService, setProviderService] = useState<DataType>(
    {} as DataType,
  );

  let { driverId } = useParams();

  const getServices = async () => {
    if (driverId) {
      setLoading(true);
      const data: Array<DataType> = await getServicesByProviderId(+driverId);
      data.forEach((x) => {
        if (x.serviceType == null) {
          x.serviceType = { id: 0, name: "Servicio eliminado" };
        }
      });
      setData(data);
      setLoading(false);
    }
  };

  useEffect(() => {
    getServices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCreatedService = () => {
    setOpen(false);
    getServices();
  };

  const onUpdatedService = () => {
    setOpenEditModal(false);
    getServices();
  };

  const toggleServiceStatus = async (record: DataType, checked: boolean) => {
    try {
      const newStatus = checked ? "active" : "offline";
      await updateProviderService({
        id: record.id,
        providerId: record.providerId,
        serviceTypeId: record.serviceTypeId,
        serviceNumber: record.serviceNumber,
        serviceModel: record.serviceModel,
        status: newStatus,
      });

      getServices();
    } catch (error) {
      notification.error({
        message: "Ha ocurrido un error al cambiar el estado del servicio.",
        placement: "top",
        key: "global",
      });
    }
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "Servicio",
      render: (_, { serviceType }) => serviceType.name,
    },
    {
      title: "N° servicio",
      dataIndex: "serviceNumber",
    },
    {
      title: "Modelo",
      dataIndex: "serviceModel",
    },
    {
      title: "Estado",
      render: (_, { status }) =>
        ProviderServiceStatus.find((x) => x.value === status)?.label || status,
    },
    {
      title: "Alternar Estado",
      key: "connection",
      render: (record: DataType) => (
        <Switch
          checked={record.status === "active"}
          disabled={record.status === "riding" || record.status === "banned"}
          onChange={(checked) => toggleServiceStatus(record, checked)}
        />
      ),
    },
    {
      title: "Editar",
      key: "edit",
      render: (record) => {
        return (
          <>
            <Button
              type="primary"
              onClick={() => {
                setOpenEditModal(true);
                setProviderService(record);
              }}
            >
              Editar
            </Button>
          </>
        );
      },
    },
  ];

  return (
    <ContainerLayout title={title} showNotification={false}>
      <Col span={24}>
        <Space>
          <Button
            type="primary"
            onClick={() => setOpen(true)}
            icon={<PlusCircleTwoTone />}
          >
            Servicio
          </Button>
          <Modal
            title="Agregar nuevo servicio"
            open={open}
            onCancel={() => setOpen(false)}
            footer={null}
          >
            <DriverServiceForm
              driverId={+(driverId || 0)}
              onSuccess={onCreatedService}
            />
          </Modal>
        </Space>
        <Modal
          title="Editar servicio"
          open={openEditModal}
          onCancel={() => setOpenEditModal(false)}
          footer={null}
        >
          <DriverServiceForm
            driverId={+(driverId || 0)}
            onSuccess={onUpdatedService}
            providerService={providerService}
          />
        </Modal>
      </Col>
      <Col span={24} style={{ width: "100px", height: "83vh" }}>
        <Table
          style={{ minWidth: "100%" }}
          columns={columns}
          rowKey={(record) => record.id}
          dataSource={data}
          loading={loading}
          pagination={false}
        />
      </Col>
    </ContainerLayout>
  );
};

export default DriverServiceList;
